import { ContentLayout8Theme } from '@components/content/components/content-layout-8/enum';
import { ContentLayout8Style } from '@components/content/components/content-layout-8/model';

export const contentLayout8Style: { [key: string]: ContentLayout8Style } = {
  [ContentLayout8Theme.CREAM]: {
    backgroundColor: 'CREAM',
    textColor: 'BLACK',
  },
  [ContentLayout8Theme.BLUE]: {
    backgroundColor: 'BLUE',
    textColor: 'WHITE',
  },
  [ContentLayout8Theme.RED]: {
    backgroundColor: 'RED',
    textColor: 'WHITE',
  },
  [ContentLayout8Theme.OPAL]: {
    backgroundColor: 'OPAL',
    textColor: 'BLACK',
  },
};
